import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Input, Checkbox, Form, Upload, Image } from 'antd';
import LoadableButton from "../../../../../components/buttons/LoadableButton.jsx";
import { DepositAmountApi } from '../../../../../api/request/wallet/cashdeposit.js';

const UsdtTrc20 = ({ amount, paymentMethod, resetAll }) => {
    const [form] = Form.useForm();
    const { userDetails } = useSelector(state => state.user);
    const [isLoading, setIsLoading] = useState(false);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [signatureFileList, setSignatureFileList] = useState([]);

    const getBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

    const extractOriginFileObjs = (fileArray) => {
        return fileArray ? fileArray.map((file) => file.originFileObj) : [];
    };

    const handleSubmit = async (values) => {
        setIsLoading(true);
        try {
            const UploadDocument = extractOriginFileObjs(values?.UploadDocument);

            let formData = new FormData();
            formData.append("UserId", userDetails?._id);
            formData.append("ReferenceId", values?.ReferenceId);
            formData.append("Comment", values?.Comment);
            formData.append("Amount", Number(amount));
            formData.append("DepositType", 2);
            UploadDocument.forEach((file) => formData.append("PaymentProof", file));

            let apiHeaders = { headers: { Accept: "application/json", "Content-Type": "multipart/form-data" } };

            const { data } = await DepositAmountApi(formData, apiHeaders);
            if (data?.success) {
                toast.success(data?.message);
                setSignatureFileList([])
                form.resetFields();
                resetAll();
            }
        } catch (error) {
            toast.error(error?.response?.data?.error?.message || 'Deposit failed.');
        } finally {
            setIsLoading(false);
        }
    }

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };

    const handleSignatureChange = ({ fileList: newSignatureList }) => {
        setSignatureFileList(newSignatureList);
        form.setFieldsValue({ UploadDocument: newSignatureList });
    };

    const UploadButton = (
        <button type="button">
            <div className='flex items-center justify-center gap-2 border rounded-md py-1.5 px-4 text-lg text-gray-500 font-medium'>
                <img src="/assets/icons/Upload_Document_icon.svg" alt="icon" className='h-5' />
                <span>Click to Upload</span>
            </div>
        </button>
    );

    return (
        <div className='flex flex-col sm:flex-row sm:items-start items-center justify-between gap-10'>
            <div className='w-full flex-1 order-2 sm:order-1'>
                <Form form={form} layout="vertical" className='space-y-5' onFinish={handleSubmit}>
                    <Form.Item
                        name='ReferenceId'
                        label={<span className="text-lg text-gray-500 font-medium">Trasaction Hash</span>}
                        rules={[{ required: true, message: 'Please enter trasaction hash.' }]}
                    >
                        <Input placeholder="Trasaction Hash" size='large' />
                    </Form.Item>

                    <Form.Item
                        name='Comment'
                        label={<span className="text-lg text-gray-500 font-medium">Comment</span>}
                    >
                        <Input placeholder="Comment" size='large' />
                    </Form.Item>

                    <Form.Item
                        name="UploadDocument"
                        label={<label className='text-lg text-[#2F2B3DCC] font-medium'>Upload Document</label>}
                    >
                        <Upload
                            beforeUpload={() => false}
                            listType="picture"
                            className="mt-1"
                            fileList={signatureFileList}
                            onPreview={handlePreview}
                            onChange={handleSignatureChange}
                        >
                            {signatureFileList.length >= 2 ? null : UploadButton}
                        </Upload>
                    </Form.Item>

                    {previewImage && (
                        <Image
                            src={previewImage}
                            wrapperStyle={{ display: 'none' }}
                            preview={{
                                visible: previewOpen,
                                onVisibleChange: (visible) => setPreviewOpen(visible),
                                afterOpenChange: (visible) => !visible && setPreviewImage(''),
                            }}
                        />
                    )}

                    <Form.Item
                        name='conditions'
                        valuePropName="checked"
                        rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')) }]}
                    >
                        <Checkbox className='mt-4'>
                            Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300'>Terms and conditions</Link>
                        </Checkbox>
                    </Form.Item>

                    <LoadableButton
                        className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
                        type="Submit"
                        lable='Submit'
                        isLoading={isLoading}
                        loadingLable='Adding request...'
                    />
                </Form>
            </div>

            <div className='order-1 sm:order-2'>
                <img src={paymentMethod?.qrCodeUrl} className='object-contain sm:h-[60%]' />
            </div>
        </div>
    )
}

export default UsdtTrc20
